import { ColumnMapping } from 'app/[lang]/(main)/translation/new/[[...args]]/_components/HubDbColumnMapping';
import { UploadedFileMetadataUpdateInput } from 'gql/graphql';

export function hubDbValidation(
  metadataInput: UploadedFileMetadataUpdateInput,
  columnMapping: ColumnMapping[]
): { isValid: boolean; errors: string[] } {
  const errors: string[] = [];

  // Check fileId
  if (typeof metadataInput?.fileId !== 'number') {
    errors.push('fileId must be a number');
  }

  // Check metadata structure
  if (!metadataInput?.metadata?.['hubdb-column-mapping']) {
    errors.push('Missing hubdb-column-mapping in metadata');
    return { isValid: false, errors };
  }

  const mapping = metadataInput.metadata['hubdb-column-mapping'];

  if (typeof mapping !== 'object' || mapping === null) {
    errors.push('hubdb-column-mapping must be an object');
    return { isValid: false, errors };
  }

  const countMapping = Object.values(mapping).flatMap((obj: any) => Object.values(obj)).length;

  if (countMapping !== columnMapping.length) {
    errors.push(`hubdb-column-mapping must have ${columnMapping.length} entries`);
  }

  // Validate each column mapping
  Object.entries(mapping).forEach(([columnName, columnData]) => {
    if (typeof columnData !== 'object' || columnData === null) {
      errors.push(`${columnName} must be an object`);
      return;
    }

    // Check if the object is empty
    if (Object.keys(columnData).length === 0) {
      errors.push(`${columnName} cannot be an empty object`);
      return;
    }

    // For title column, allow empty strings - for others, validate normally
    Object.entries(columnData).forEach(([key, value]) => {
      if (typeof key !== 'string' || key.trim() === '') {
        errors.push(`${columnName} has invalid key: keys must be non-empty strings`);
      }
      if (typeof value !== 'string') {
        errors.push(`${columnName}.${key} must be a string`);
      }
      // Empty strings aren't allowed for title column
      if (value === '') {
        errors.push(`${columnName}.${key} cannot be empty`);
      }
    });
  });

  return { isValid: errors.length === 0, errors };
}
